/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Reviews_Criticreviews2Inputs */

const id_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ulasan Kritikus`)
};

const ms_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ulasan Pengkritik`)
};

const da_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kritikeranmeldelser`)
};

const de_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kritikerbewertungen`)
};

const en_us2_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Critic Reviews`)
};

const es_es2_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reseñas de críticos`)
};

const es_mx2_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reseñas de críticos`)
};

const fil_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Review ng Kritiko`)
};

const fr_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avis de la presse`)
};

const it_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recensioni della critica`)
};

const hu_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kritikai értékelések`)
};

const nl_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criticusreviews`)
};

const no_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kritikeromtaler`)
};

const pl_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recenzje krytyków`)
};

const pt_br2_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Críticas`)
};

const pt_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avaliações de críticos`)
};

const ro_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recenzii ale criticilor`)
};

const fi_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kriitikoiden arvostelut`)
};

const sv_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kritikerrecensioner`)
};

const vi_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đánh giá từ nhà phê bình`)
};

const tr_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eleştirmen Yorumları`)
};

const cs_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kritické recenze`)
};

const bg_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Критически ревюта`)
};

const ru_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обзоры критиков`)
};

const uk_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відгуки критиків`)
};

const ar_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مراجعات النقاد`)
};

const hi_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आलोचक समीक्षाएँ`)
};

const th_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รีวิวนักวิจารณ์`)
};

const ja_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`批評家レビュー`)
};

const zh_cn2_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体评分`)
};

const zh_hant1_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒體評分`)
};

const ko_offerdetail_reviews_criticreviews2 = /** @type {(inputs: Offerdetail_Reviews_Criticreviews2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비평가 리뷰`)
};

/**
* | output |
* | --- |
* | "Critic Reviews" |
*
* @param {Offerdetail_Reviews_Criticreviews2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_reviews_criticreviews2 = /** @type {((inputs?: Offerdetail_Reviews_Criticreviews2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Reviews_Criticreviews2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "ms") return ms_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "da") return da_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "de") return de_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "fil") return fil_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "fr") return fr_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "it") return it_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "hu") return hu_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "nl") return nl_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "no") return no_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "pl") return pl_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "pt") return pt_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "ro") return ro_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "fi") return fi_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "sv") return sv_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "vi") return vi_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "tr") return tr_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "cs") return cs_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "bg") return bg_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "ru") return ru_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "uk") return uk_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "ar") return ar_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "hi") return hi_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "th") return th_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "ja") return ja_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_reviews_criticreviews2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_reviews_criticreviews2(inputs)
	return ko_offerdetail_reviews_criticreviews2(inputs)
});
export { offerdetail_reviews_criticreviews2 as "offerDetail.reviews.criticReviews" }